var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSportsAz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON_Square_Right",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.91406 11.4453L10.0859 15H13.875L15.0469 11.4453L12 9.25781L8.91406 11.4453ZM11.9609 2.5C6.45312 2.5 2 6.99219 2 12.5C2 18.0469 6.45312 22.5 12 22.5C17.5078 22.5 21.9609 18.0469 21.9609 12.5391C21.9609 7.07031 17.5078 2.5 11.9609 2.5ZM18.25 16.6016L14.9297 16.5625L13.9531 19.7656C13.3281 19.9219 12.6641 20 12 20C11.2969 20 10.6328 19.9219 10.0078 19.7656L9.03125 16.5625L5.71094 16.6016C5.00781 15.5469 4.57812 14.2578 4.5 12.8906L7.23438 10.9766L6.14062 7.8125C6.96094 6.79688 8.05469 5.97656 9.30469 5.50781L12 7.5L14.6562 5.50781C15.9062 6.01562 17 6.79688 17.8203 7.8125L16.7266 10.9766L19.4609 12.8906C19.3828 14.2578 18.9531 15.5469 18.25 16.6016Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsAz);
export default ForwardRef;